import http from './axios'

// 查询列表
const queryPage = ({ channel, uvStart, uvEnd, startTime, endTime }) => {
    return http.get('/manager/dailyReport/dailyChannelUv', {
        channel,
        uvStart,
        uvEnd,
        startTime,
        endTime,
    })
}

export default {
    queryPage,
}